import { Flex, Grid, Text } from "@chakra-ui/react";
import { NewOrderType, useNewOrderStore } from "../../../stores/order.store";
import PageTitle from "../../../components/PageTitle";
import BrandWarnIcon from "../../../components/icons/BrandWarnIcon";
import { CardSelectable } from "./CardSelectable";
import { OrdersNewPageBaseLayout } from "./OrdersNewPageBaseLayout";
import { OrdersNewPageBaseLayoutButton } from "./OrdersNewPageBaseLayoutButton";

export const ChooseCommandTypeLayout = () => {
	const { type, setType } = useNewOrderStore();
	return (
		<OrdersNewPageBaseLayout>
			<Flex direction="column" gap={12} alignItems="center">
				<PageTitle>De quel type de commande s'agit-il&nbsp;?</PageTitle>

				<Flex direction="column" gap={4} w="40rem">
					<CardSelectable
						title="Nouvelle commande"
						subtitle="Vous souhaitez utiliser de nouvelles empreintes"
						activated={type === NewOrderType.NEW}
						onClick={() => setType(NewOrderType.NEW)}
					/>
					<CardSelectable
						title="Refonte"
						subtitle={
							<Grid
								gridTemplateColumns={"32px 1fr"}
								gap={2}
								alignItems={"start"}
								pt={2}
							>
								<BrandWarnIcon w="32px" h="32px" />
								<Text fontSize="16px">
									Les refontes sont réalisées{" "}
									<span className="text-[#DC2626] font-bold">
										uniquement à partir des empreintes déjà en notre possession
										:
									</span>{" "}
									toute nouvelle empreinte doit être saisie via "Nouvelle
									commande".
								</Text>
							</Grid>
						}
						activated={type === NewOrderType.REWORK}
						onClick={() => setType(NewOrderType.REWORK)}
					/>
				</Flex>

				<OrdersNewPageBaseLayoutButton />
			</Flex>
		</OrdersNewPageBaseLayout>
	);
};
